<template>
  <label class="checkbox">
    <input
      :id="id"
      class="checkbox__input"
      :value="value"
      :checked="checked"
      type="checkbox"
      @change="onChange"
    />
    <div class="checkbox__box" />
    <slot />
  </label>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'InputCheckbox',

    props: {
      id: {
        type: String as PropType<string>,
        required: true,
      },

      value: {
        type: Boolean as PropType<boolean>,
        required: true,
      },
    },

    emits: ['onInput'],

    computed: {
      checked() {
        return this.value;
      },
    },

    methods: {
      onChange(_event: Event) {
        // @ts-expect-error emit is not typed in options API
        this.$emit('onInput', !this.value);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .checkbox {
    display: inline-block;
    font-family: $text-font--1;
    @include smallText;
    line-height: 25px;
    padding-left: 34px;
    position: relative;
    cursor: pointer;
    user-select: none;

    @include hover {
      .checkbox__box {
        border-color: #c722ca;
      }
    }

    &__input {
      appearance: none;
      position: absolute;
      // polyfill
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      outline: none;

      &:checked {
        & + .checkbox__box {
          border-color: #c722ca;
          background-color: #c722ca;

          @include hover {
            border-color: #83218d;
            background-color: #83218d;
          }

          &:before {
            @include okMask;
            background: #fff;
          }
        }
      }
    }

    &__box {
      position: absolute;
      left: 0;
      top: 0;
      width: 16px;
      height: 16px;
      border: 1px solid #4c4c4c;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 4px;

      &:before {
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: transparent;
      }
    }
  }
</style>
